import type { ReactElement } from 'react';
import { Link } from 'react-router';

import { useMasterListAccess } from '../use-master-list-access';

// Regreso desde un aviso de la ficha o del editor (G4, cierre F1, FUN-06): a la Lista
// Maestra solo si la persona tiene acceso a ella; si no, al Panel, sin nombrarla.

export function BackToListLink(): ReactElement {
  const access = useMasterListAccess();
  return access.state === 'granted' ? (
    <Link to="/documentos">Volver a la Lista Maestra</Link>
  ) : (
    <Link to="/dashboard">Ir al Panel</Link>
  );
}
